import styled from "styled-components";

export const GreenBadge = styled.div`
    background-color: #6dd67d55;
    color: #00c41d;
    font-weight: bold;
    border-radius: 4px;
    width: fit-content;
    padding: 0 8px;
    margin: auto;

`;
export const RedBadge = styled.div`
    background-color: #ff828255;
    font-weight: bold;
    color: #a60505;
    border-radius: 4px;
    width: fit-content;
    padding: 0 8px;
    margin: auto;
`;